import { sizeConstants } from "../../constants";
import { sizeService } from "../../services";
import { alertActions } from "../alert.actions";

export const sizeActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    sizeService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: sizeConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: sizeConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: sizeConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code, status) {
  return (dispatch) => {
    dispatch(request(name, code, status));

    sizeService.addParameter(name, code, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: sizeConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: sizeConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: sizeConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code, status) {
  return (dispatch) => {
    dispatch(request(id, name, code, status));

    sizeService.updateParameter(id, name, code, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: sizeConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: sizeConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: sizeConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    sizeService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: sizeConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: sizeConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: sizeConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: sizeConstants.CLEAR };
}
